import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiResponse, ResponseStatus, PayloadResponse } from '../models/response.model';
import { CheckRegisterAndValidateDataReference,CheckRegisterAndValidateDataReferenceRespond } from '../models/verify.model';
@Injectable({
  providedIn: 'root'
})
export class VerifyReferenceService {

  constructor(private http: HttpClient) { }

  apicheckRegisterAndValidateDataReference(body: CheckRegisterAndValidateDataReference): Observable<CheckRegisterAndValidateDataReferenceRespond> {
    // return new Observable(res => res.next(this.mock))
    return this.http.post<ApiResponse<CheckRegisterAndValidateDataReferenceRespond>>(environment.endpointBackend + '/api/line/verify/referenceRegistration', body).pipe(
      map(
        result => {
          switch (result.response_code) {
            case ('40000'):
              return result.payload
            default:
              return null
          }
        }
      )
    )
  }
}
